import React from 'react';
import { useMode, MODES } from '../contexts/ModeContext';
import { canSeeTrainingMode, canSeeReference } from '../utils/featureAccess';

function ModeIndicator({ showSwitchButtons = true, user = null }) {
  const { 
    currentMode, 
    modeConfig, 
    requestModeSwitch,
    isReferenceMode,
    isTrainingMode 
  } = useMode();

  // Check if user can see training mode features
  const canAccessTraining = canSeeTrainingMode(user);
  const canAccessReference = canSeeReference(user);

  // If user can't access training mode, always show Reference Mode only
  // and don't show the switch buttons
  const effectiveShowSwitchButtons = showSwitchButtons && (canAccessTraining || canAccessReference);

  return (
    <div className="mode-indicator-container">
      {/* Current Mode Badge - Always Visible */}
      <div 
        className={`mode-badge ${currentMode}`}
        style={{ 
          backgroundColor: modeConfig.bgColor,
          borderColor: modeConfig.borderColor 
        }}
        title={modeConfig.shortLabel}
        data-testid="mode-badge"
      >
        <span 
          className="mode-icon"
          style={{ color: modeConfig.iconColor }}
        >
          {isReferenceMode ? '🔵' : '🟡'}
        </span>
        <span className="mode-label" style={{ color: modeConfig.iconColor }}>
          {isReferenceMode ? 'Reference Mode' : 'Training Mode'}
        </span>
      </div>

      {/* Mode Switch Buttons - Only show if user has access */}
      {effectiveShowSwitchButtons && (
        <div className="mode-switch-buttons">
          {isTrainingMode && canAccessReference && (
            <button
              className="btn-switch-mode btn-to-reference"
              onClick={() => requestModeSwitch(MODES.REFERENCE)}
              title="Switch to Reference Mode — Live Work Safe"
              data-testid="btn-switch-to-reference"
            >
              🔵 Switch to Reference Mode
            </button>
          )}
          {isReferenceMode && canAccessTraining && (
            <button
              className="btn-switch-mode btn-to-training"
              onClick={() => requestModeSwitch(MODES.TRAINING)}
              title="Switch to Training Mode — Not for Live Work"
              data-testid="btn-switch-to-training"
            >
              🟡 Switch to Training Mode
            </button>
          )}
        </div>
      )}
    </div>
  );
}

export default ModeIndicator;
